export default __webpack_public_path__ + "static/media/17.86b70fb0.jpg";